import { _black, StyledSvg, SvgPropsType } from "../common/CommonSvg"

// 폴더 
export const SvgFolder = (({$fillColor}:SvgPropsType ) => {
  return <StyledSvg $fillColor={$fillColor || _black }  viewBox="3 4 18 17" fill="none">
   <path d="M21 8.27273C21 7.36899 20.2674 6.63636 19.3636 6.63636H12.0015C12.0343 6.63619 12.0239 6.6235 11.9519 6.53598C11.9342 6.51449 11.9129 6.48848 11.8875 6.45703C11.8624 6.42596 11.7923 6.33563 11.7306 6.2561C11.6869 6.1998 11.6472 6.14858 11.631 6.12815C11.0451 5.38901 10.4618 5 9.54545 5H4.63636C3.73262 5 3 5.73262 3 6.63636V18.0909C3 18.9946 3.73262 19.7273 4.63636 19.7273H19.3636C20.2674 19.7273 21 18.9946 21 18.0909V8.27273Z" />
  </StyledSvg>
})
